<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal15" :class="type == 2 ? 'modal-mask' : 'modal-mask1'" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop  style="max-width: 100%;">
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"  style="color: #6c757d !important;"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png"  />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body" style="min-height: 700px;">
              <div class="modal_reps_to_review d-none-">



                <div class="row mb-2 mt-3">
                  <div class="col-6 pl-4">
                    <div class="h3 d-inline mr-2 text-uppercase">{{ menteeShortName }}</div>
                    <button class="text-uppercase btn btn-primary d-none mentee_title_btn">Apprentice</button>
                  </div>
                  <div class="col-6 pr-4 text-right">
                    <div class="text-muted">Mentor(s)</div>
                    <ul class="list-inline">
                      <li class="list-inline-item font-weight-bold" v-for="(mentorAssigned, index) in mentorsAssigned" :key="index">{{ mentorAssigned.name }}</li>
                    </ul>                
                  </div>              
                </div>

                <div>
                  <div class="mt-1 mb-3 pl-3 pr-3">
                    <div class="row align-items-end">
                      <div class="col px-2 text-center" v-for="(pathwayStep, index) in pathwayStepsData.mentee_pathway_steps">
                        <p class="text-uppercase mb-1 " 
                          :class="activeStep == pathwayStep.id ? 'pw_step_title_active' : 'pw_step_title'" >
                          <span :style="activeStep == pathwayStep.id ? 'background-color: ' + pathwayStepsData.mentee_pathway.ascentColor + ';' : ''">{{ pathwayStep.stepTitle }}</span>
                        </p>
                        <div class="progress progress_pathway">
                          <div class="progress-bar progress_bar_100" :style="'width:' + pathwayStep.percentage_completion + '%;'"></div>
                        </div>
                      </div>        
                    </div>
                  </div>
                </div>



                <div class="row mx-2 mb-3">
                  <div class="col p-0" style="font-size: 18px; font-weight: bold; border-bottom: 1px solid #CCC">
                    Upload Course Certificate
                  </div>

                </div>

    <div class="row mx-2 mb-3" style="">
      <div class="col-1" style="padding-left: 0px;">
        <div class="progress-circle" >
          <img :src="certificates.image" width="50px" height="50px" />
        </div>
      </div>

      <div class="col-7 col-xl-8 pl-3" style="font-size: 15px; padding-top: 12px;">
        <p class="mb-0">{{ certificates.name }}</p>
      </div>
    </div>
                <div class="row align-items-center mb-3">
                  <div class="col-12" style="padding-right: 15px;">
                    <div class="px-2">
                      <div class="row">
                        <div class="col-6" >
                          <div class="dropbox" v-if="isInitial">
                            <input 
                              type="file" 
                              name="pdf_file"
                              ref="pdf_file"
                              accept="type/pdf,image/jpeg,image/png"
                              @change="filesChange($event.target.name, $event.target.files)"
                              class="input-file">
                              <p v-if="isInitial" style="padding: 0px 0px 0px 0px; margin-bottom: 0; text-align: center;">
                                <img class="" height="35px" src="@/assets/manager/Mentor Mentee System Icons.png"  />
                              </p>
                              <p style="padding: 10px 0px 0px 0px; margin-bottom: 0; font-weight: bold;">Drag and drop a file to upload</p>
                              <p  style="padding: 0px 0px 15px 0px; font-size: 13px;  margin-bottom: 0;">PDF, PNG or JPG upto 5 MB</p>
                              <p style="font-size: 18px; font-weight: bold; padding: 0px 0px 10px 0px; margin-bottom: 0;">OR</p>
                              <p style=" padding: 5px 0px 0px 0px; text-align: center;  margin-bottom: 2px;">
                                <button
                                
                                class="btn  ma-blue-btn btn-md input-height-15 text-center" style="border-radius: 15px !important;"
                                >Browse Files</button>
                              </p>
                            </div>
                            <div class="dropbox1" v-if="isSaving">
                              <p>
                                <div class="row">
                                  <div class="col-2 " style="padding-top: 20px; padding-left: 30px;">
                                    <img class="" height="25px" src="@/assets/manager/Mentor Mentee Upload File.png"  />
                                  </div>
                                  <div class="col-8 pt-2">
                                    <div class="col p-0" style="font-size: 15px; font-weight: bold;">{{ filename }}</div>
                                    <div class="col-12 p-0">
                                      <div class="progress progress_pathway" style="height: 8px">
                                        <div class="progress-bar progress_bar_100" style="width: 100%"></div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-6">
                                        {{ totalSizeMB }}MB
                                      </div>
                                      <div class="col-6 text-align-right">
                                        100%
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-1" style="padding-top: 25px;">
                                    <button type="button" class="close float-right" @click="removeFile()">
                                      <span aria-hidden="true">&times;</span>
                                    </button>                             
                                  </div>
                                </div>
                              </p>
                          </div>
                          <p v-if="uploadError" class="text-danger">{{uploadError}}</p>
                        </div>
                        <div class="col-6" >
                          <div class="row">
                          <div class="col-6 text-align-right pt-1">
                            Issued Date: 
                          </div>
                          <div class="col-6 datepicker-custom">
                            <date-picker
                              v-model="issued_date"
                              placeholder="DD/MM/YY"
                              format="DD/MM/YY"
                              v-bind:clearable="false"
                              :disabled-date="disabledAfterToday"
                              input-class="col-lg-12 input-class input-height-25 text-align-right"
                              >
                              <template v-slot:icon-calendar>
                                <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                              </template>
                            </date-picker>
                          </div>
                          </div>
                          <div class="row pt-3">
                          <div class="col-6 text-align-right pt-1">
                            Expiration Date: 
                          </div>
                          <div class="col-6">
                            <date-picker
                              v-model="expiration_date"
                              placeholder="DD/MM/YY"
                              format="DD/MM/YY"
                              v-bind:clearable="false"
                              input-class="col-lg-12 input-class input-height-25 text-align-right"

                              >
                              <template v-slot:icon-calendar>
                                <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                              </template>
                            </date-picker>

                          </div>
                          </div>
                          <div class="row pt-4" style="padding-top: 50px !important;">
                            <div class="col">
                              <button v-if="disable_add == true" disabled="true" class="btn btn-dard-grey btn-md input-height-15 float-right text-align-right" style="border-radius: 15px;">Upload Certificate</button>
                              <button v-else  
                              :disabled="disable_add"
                              @click="onSubmit()"
                              class="btn  ma-blue-btn btn-md input-height-15 float-right text-align-right" style="border-radius: 15px !important;"
                              >Upload Certificate</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import MenteePathwayProgress from '@/components/manager/mentee_pathway_progress.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
  props: ['isModalVisible', 'type'],
  data() {
    return {
      uploadError: '',
      loading: false,
      currentStatus: null,
      uploadedFiles: [],
      menteeId: '',
      courseId: '',
      stepId: '',
      objectiveId: '',
      issued_date: '',
      expiration_date: '',
      verification_code: '',
      certificates: [],
      filename: '',
      disable_add: true,
      ref_pdf_file: {},
      menteeFirstName: '',
      menteeShortName: '',
      mentorsAssigned: [],
      pathwayStepsData: [],
      activeStep: '',
    }
  },
  computed: {
          isInitial() {
            return this.currentStatus === STATUS_INITIAL;
          },
          isSaving() {
            return this.currentStatus === STATUS_SAVING;
          },
          isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
          },
          isFailed() {
            return this.currentStatus === STATUS_FAILED;
          }
    
  },
  methods: {
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today
    },
    hide() {
      this.$emit('closeTaskListModal');
    },
    removeFile() {
      this.filename == '';
      this.disable_add = true;
      this.ref_pdf_file = {};
      this.currentStatus = STATUS_INITIAL;
    },
    dovalidate() {
      var vflag = 1;
      if((this.issued_date == '')) {
        alert("Please enter issue date");
        vflag = 0;
        return false
      }
      if((this.issued_date != '') && (this.expiration_date != '')) {
        if(this.issued_date > this.expiration_date) {
          alert("Expiration date should be greater than issued date");
          vflag = 0;
          return false
        }
      }
      if(this.filename == '') {
        alert("Please upload Certificate");
        vflag = 0;
        return false;
      }
      else if(this.ref_pdf_file.files[0].size > 5000000) {
        alert("Certificate size should be of 5 MB only");
        vflag = 0;
        return false;
      }
      else {
        if((this.ref_pdf_file.files[0].type != 'image/jpeg') && (this.ref_pdf_file.files[0].type != 'image/jpg') && (this.ref_pdf_file.files[0].type != 'image/png') && (this.ref_pdf_file.files[0].type != 'application/pdf')) {
          alert("Image should be of jpeg, jpg, png, pdf formats only");
          vflag = 0;
          return false;
          }
      }
      return vflag;
    },
    filesChange(fieldName, fileList) {
      this.currentStatus = STATUS_SAVING;
      this.filename = this.$refs.pdf_file.files[0].name;
      this.totalSizeMB = this.$refs.pdf_file.files[0].size / Math.pow(1024,2);
      this.totalSizeMB = parseFloat(this.totalSizeMB).toFixed(2);
      this.ref_pdf_file = this.$refs.pdf_file;
      this.disable_add = false;
    },
    onSubmit() {
      var vflag = this.dovalidate();
      if(vflag == 1) {
      this.disable_add = true;
              const issueDateStr = moment(this.issued_date).format('YYYY-MM-DD HH:mm:ss')
              const expirationDateStr = moment(this.expiration_date).format('YYYY-MM-DD HH:mm:ss')

              const pdfData = new FormData();
              pdfData.append("pdf_file", this.ref_pdf_file.files[0], this.ref_pdf_file.files[0].name);
              pdfData.append("mentee_id", this.menteeId);
              pdfData.append("account_id", this.$store.state.user_accountid);
              pdfData.append("course_id", this.courseId);
              pdfData.append("objective_id", this.objectiveId);
              pdfData.append("issue_date", issueDateStr);
              pdfData.append("expiration_date", expirationDateStr);
              pdfData.append("verification_code", this.verification_code);

              axios.post('/mentee-upload-course-certificate', pdfData, {
                  headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Accept': 'application/pdf, image/png, image/jpg',
                    'Content-Type': 'multipart/form-data'
                  },
              })
              .then(resp => {
                this.hide();
              })
              .catch(error => {
                this.uploadError = error.response.data.message;
                this.currentStatus = STATUS_FAILED;
              })
      }
    },

    getMenteeCertificatesData(menteeId, courseId, stepId, objectiveId) {
      this.currentStatus = STATUS_INITIAL;
      this.menteeId = menteeId;
      this.loading = true;
      this.courseId = courseId;
      this.stepId = stepId;
      this.objectiveId = objectiveId;
      
      axios('/desktop/get-mentee-repitition-lists-all-tasklists', {
        method: 'GET',
        params: {
          mentee_id: this.menteeId,
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.menteeFirstName = data.mentee_first_name;
        this.menteeShortName = data.mentee_short_name;
        this.repCount = data.rep_count;
        this.repTasks = data.rep_tasks;
        this.mentorsAssigned = data.mentors_assigned;
      })
      .catch(() => {});

      axios('/desktop/v2/pathway/get-mentee-pathway-progress', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: this.menteeId, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.pathwayStepsData = data;
        this.activeStep = this.pathwayStepsData.mentee_pathway.currentStep;
        this.pathwayId = this.pathwayStepsData.mentee_pathway.id;
        this.showFutureSteps = this.pathwayStepsData.mentee_pathway.showFutureSteps;
      })
      .catch(() => {});


        axios('/desktop/v2/get-mentee-course-certification-details', {
          method: 'GET',
          params: {
            courseId: this.courseId,
          }
        })
        .then(resp => {
          this.certificates = resp.data.certificates;
          this.searchTextFlag = true;
        })
        .catch(() => {});
      
      
      setTimeout(() => {
        let element = document.getElementById('groupModal15');    
        element.scrollIntoView(true);
      }, 2000); 
    },
  },
  components: {
    MenteePathwayProgress,
    DatePicker,
  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}


::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
@media (max-width: 1199.98px) {
  .progress_item_link {
    font-size: 13px;
    cursor: pointer;
  }
}
.progress_item_link {
  cursor: pointer;
}
.objective-view-icon {
  width: 15px;
  margin-left: 2px !important;
}
.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
}
.search_tasks_txtbox input:active,
.search_tasks_txtbox input:focus,
.search_tasks_txtbox input:hover {
  border-color: #ced4da !important;
}
.search_tasks_txtbox .input-group-text {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
/* Upload Form CSS Start */
.dropbox {
  border: 1px dashed grey; /* the dash box */
  border-radius: 10px;
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 180px; /* minimum height */
  position: relative;
  cursor: pointer;
}
.dropbox1 {
  border: 1px solid grey; /* the dash box */
  border-radius: 10px;
  outline-offset: -10px;
  background: white;
  min-height: 80px;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: white; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
/* Upload Form CSS End */
.input-class  {
  border: 1px solid #002F42; 
  border-radius: 10px;
}
.mx-datepicker {
  width: auto;
}
.mx-datepicker .input-class {
  border-radius: 10px;
  //padding-right: 25px;
  border: 1px solid #002F42; 
}
.progress_pathway {
  height:8px;
  margin-top: 5px;
}
.progress_pathway {
  height:5px;
  margin-top: 5px;
}
.pw_step_title {
  font-size: 12px;
}
.pw_step_title_active {
  font-size: 12px;
}
.pw_step_title_active span {
  color: #FFFFFF;
  padding: 0px 6px;
  border-radius: 4px;
  display: inline-block;
}

</style>
<style>
.mx-datepicker .input-class {
  border-radius: 10px;
  padding-right: 25px;
  border: 1px solid #002F42; 
}
.mx-datepicker-popup {
  position: absolute !important;
  z-index: 99999;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/mentee_upload_course_certificate.vue